export default "__VITE_PUBLIC_ASSET__ed3e51ed__"